import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  MissionControllerDtoBasicAccountInfoListRequest,
  MissionControllerDtoBasicAccountInfoListResponse,
  MissionControllerDtoBasicAccountPointLogListRequest,
  MissionControllerDtoBasicAccountPointLogListResponse,
  MissionControllerDtoBasicGradeRewardLogListRequest,
  MissionControllerDtoBasicGradeRewardLogListResponse,
  MissionControllerDtoBasicInvitedUsersListRequest,
  MissionControllerDtoBasicInvitedUsersListResponse,
  MissionControllerDtoMissionFreeInfoAddBudgetRequest,
  MissionControllerDtoMissionFreeInfoCreateRequest,
  MissionControllerDtoMissionFreeInfoDepositRequest,
  MissionControllerDtoMissionFreeInfoDetailRequest,
  MissionControllerDtoMissionFreeInfoListRequest,
  MissionControllerDtoMissionFreeInfoRemoveRequest,
  MissionControllerDtoMissionFreeInfoUpdateRequest,
  PerplayMissionApi
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import MissionControllerDtoMissionFreeInfoListResponse
  from '../../models/src/model/MissionControllerDtoMissionFreeInfoListResponse';
import {
  BASIC_MISSION_CREATE_REQUEST,
  BASIC_MISSION_INFO_ADD_BUDGET_REQUEST,
  BASIC_MISSION_INFO_DEPOSIT_REQUEST,
  BASIC_MISSION_INFO_DETAIL_REQUEST,
  BASIC_MISSION_INFO_REMOVE_REQUEST,
  BASIC_MISSION_INFO_UPDATE_REQUEST,
  BASIC_MISSION_LIST_REQUEST,
  BASIC_REFERRAL_ACCOUNT_INFO_LIST_REQUEST, BASIC_REFERRAL_GRADE_REWARD_LOG_LIST_REQUEST,
  BASIC_REFERRAL_INVITED_USER_LIST_REQUEST,
  BASIC_REFERRAL_POINT_LOG_LIST_REQUEST,
} from '../../constants/app/basicConstants';
import BaseResponse from '../../models/src/model/BaseResponse';
import MissionControllerDtoMissionFreeInfoDetailResponse
  from '../../models/src/model/MissionControllerDtoMissionFreeInfoDetailResponse';

const api = new PerplayMissionApi(config.API_CLIENT);

function* basicMissionListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoMissionFreeInfoListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionMissionFreeInfoListPost({ missionControllerDtoMissionFreeInfoListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MissionControllerDtoMissionFreeInfoListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicMissionCreateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoMissionFreeInfoCreateRequest();
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    requestData.conditionAt = payload.conditionAt;
    requestData.initialPer = payload.initialPer;
    requestData.initialXper = payload.initialXper;
    requestData.dailyData = payload.dailyData;
    requestData.achievementData = payload.achievementData;
    requestData.walletNo = payload.walletNo;
    requestData.depositTransactionStatus = payload.depositTransactionStatus;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionMissionFreeInfoCreatePost({ missionControllerDtoMissionFreeInfoCreateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicMissionInfoDetailRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoMissionFreeInfoDetailRequest();
    requestData.missionNo = payload.missionNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionMissionFreeInfoDetailPost({ missionControllerDtoMissionFreeInfoDetailRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MissionControllerDtoMissionFreeInfoDetailResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicMissionInfoDepositRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoMissionFreeInfoDepositRequest();
    requestData.missionNo = payload.missionNo;
    requestData.tokenType = payload.tokenType;
    requestData.transactionHash = payload.transactionHash;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionMissionFreeInfoDepositPost({ missionControllerDtoMissionFreeInfoDepositRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicMissionInfoAddBudgetRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoMissionFreeInfoAddBudgetRequest();
    requestData.missionNo = payload.missionNo;
    requestData.addPer = payload.addPer;
    requestData.addXper = payload.addXper;
    requestData.transactionHash = payload.transactionHash;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionMissionFreeInfoAddBudgetPost({ missionControllerDtoMissionFreeInfoAddBudgetRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicMissionInfoUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoMissionFreeInfoUpdateRequest();
    requestData.missionNo = payload.missionNo;
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    requestData.conditionAt = payload.conditionAt;
    requestData.dailyData = payload.dailyData;
    requestData.achievementData = payload.achievementData;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionMissionFreeInfoUpdatePost({ missionControllerDtoMissionFreeInfoUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicMissionInfoRemoveRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoMissionFreeInfoRemoveRequest();
    requestData.missionNo = payload.missionNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionMissionFreeInfoRemovePost({ missionControllerDtoMissionFreeInfoRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicReferralAccountInfoListRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback 설정되지 않았습니다.',
    });

    try {
        const requestData = new MissionControllerDtoBasicAccountInfoListRequest();
        requestData.accountNo = payload.accountNo;
        requestData.inviteCode = payload.inviteCode;
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayMissionBasicAccountInfoListPost({ missionControllerDtoBasicAccountInfoListRequest: requestData }, () => {});
        const data = api.apiClient.deserialize(result, MissionControllerDtoBasicAccountInfoListResponse);

        // if (data.resultCode !== 200) {
        //   throw new Error(getErrorMessage(data));
        // }
        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* basicReferralInvitedUserListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoBasicInvitedUsersListRequest();
    requestData.inviterAccountNo = payload.inviterAccountNo;
    requestData.invitedAccountNo = payload.invitedAccountNo;
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionBasicInvitedUsersListPost({ missionControllerDtoBasicInvitedUsersListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MissionControllerDtoBasicInvitedUsersListResponse);

    // if (data.resultCode !== 200) {
    //   throw new Error(getErrorMessage(data));
    // }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicReferralPointLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoBasicAccountPointLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.accountNo = payload.accountNo;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionBasicAccountPointLogListPost({ missionControllerDtoBasicAccountPointLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MissionControllerDtoBasicAccountPointLogListResponse);

    // if (data.resultCode !== 200) {
    //   throw new Error(getErrorMessage(data));
    // }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicReferralGradeRewardLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.',
  });

  try {
    const requestData = new MissionControllerDtoBasicGradeRewardLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.accountNo = payload.accountNo;
    requestData.contentNo = payload.contentNo;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayMissionBasicGradeRewardLogListPost({ missionControllerDtoBasicGradeRewardLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, MissionControllerDtoBasicGradeRewardLogListResponse);

    // if (data.resultCode !== 200) {
    //   throw new Error(getErrorMessage(data));
    // }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* missionRootSaga() {
  yield all([
    takeEvery(BASIC_MISSION_LIST_REQUEST, basicMissionListRequestSaga),
    takeEvery(BASIC_MISSION_CREATE_REQUEST, basicMissionCreateRequestSaga),
    takeEvery(BASIC_MISSION_INFO_DETAIL_REQUEST, basicMissionInfoDetailRequestSaga),
    takeEvery(BASIC_MISSION_INFO_DEPOSIT_REQUEST, basicMissionInfoDepositRequestSaga),
    takeEvery(BASIC_MISSION_INFO_ADD_BUDGET_REQUEST, basicMissionInfoAddBudgetRequestSaga),
    takeEvery(BASIC_MISSION_INFO_UPDATE_REQUEST, basicMissionInfoUpdateRequestSaga),
    takeEvery(BASIC_MISSION_INFO_REMOVE_REQUEST, basicMissionInfoRemoveRequestSaga),
    takeEvery(BASIC_REFERRAL_ACCOUNT_INFO_LIST_REQUEST, basicReferralAccountInfoListRequestSaga),
    takeEvery(BASIC_REFERRAL_INVITED_USER_LIST_REQUEST, basicReferralInvitedUserListRequestSaga),
    takeEvery(BASIC_REFERRAL_POINT_LOG_LIST_REQUEST, basicReferralPointLogListRequestSaga),
    takeEvery(BASIC_REFERRAL_GRADE_REWARD_LOG_LIST_REQUEST, basicReferralGradeRewardLogListRequestSaga),
  ]);
}

const basicSagas = [
  fork(missionRootSaga)
];

export default basicSagas;
